module.exports = __webpack_public_path__ + "media/images/icons/icon_filter_gray-827af59750d59ee28cdea0a981472029.svg";